var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.type,on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }